"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLogStream = deleteLogStream;
const client_cloudwatch_logs_1 = require("@aws-sdk/client-cloudwatch-logs");
function deleteLogStream(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { logGroupName, logStreamName } = params;
        const cloudWatchLogsClient = new client_cloudwatch_logs_1.CloudWatchLogsClient();
        try {
            const command = new client_cloudwatch_logs_1.DeleteLogStreamCommand({
                logGroupName,
                logStreamName,
            });
            yield cloudWatchLogsClient.send(command);
        }
        catch (error) {
            console.error(`Error deleting log stream: ${logStreamName} from log group: ${logGroupName}`, error);
            throw error;
        }
    });
}
